var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{attrs:{"cardValue":_vm.cardValue},nativeOn:{"click":function($event){return _vm.goBack($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }